import {Box, Button, Grid, Paper, Typography} from "@mui/material";
import React, {useState} from "react";
import {styled, useTheme} from '@mui/material/styles';
import UploadIcon from '@mui/icons-material/Upload';
import {BarLoader} from "react-spinners";


const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

function DeckSelectionGridView({decks, builtinDeckSelectedCallBack, customDeckUploadedCallback}) {

    const theme = useTheme();

    const [currentlyUploadingFile, setCurrentlyUploadingFile] = useState(false);
    const [fileUploadErrorMessage, setFileUploadErrorMessage] = useState('');


    function handleCustomFileUpload(event) {
        setCurrentlyUploadingFile(true);
        customDeckUploadedCallback(event.target.files[0])
            .then(() => {
                setCurrentlyUploadingFile(false);
                setFileUploadErrorMessage('');
            })
            .catch((error) => {
                setCurrentlyUploadingFile(false);
                setFileUploadErrorMessage(error);
            });
    }


    function SingleItem({title, contentComponent, buttonComponent}) {
        return (
            <Grid item xs={12} sm={6} md={4} lg={4}>
                <Paper elevation={5}
                       square={false}
                       sx={{backgroundColor: theme.palette.neutral.main, borderRadius: 2, height: '100%', position: 'relative', transition: "transform 0.15s ease-in-out", "&:hover": {transform: "scale3d(1.05, 1.05, 1)"}}}>
                    <Box p={2}>
                        <Box display="flex" justifyContent="space-between">
                            <Typography variant="h6" fontWeight="bold">{title}</Typography>
                            {buttonComponent}
                        </Box>
                        {contentComponent}
                    </Box>
                </Paper>
            </Grid>
        )
    }


    return (
        <div>
            {decks.length > 0 && (
                <div>
                    <Typography variant="h4" fontWeight="bold" align="center" sx={{mb: 4}}>Select word list</Typography>
                    <Grid container spacing={3} justifyContent="center">
                        {decks.map(([title, description, wordCount], index) => (
                            <SingleItem key={index}
                                        title={title}
                                        contentComponent={(
                                            <div>
                                                <Typography variant="body1">{`${wordCount} words`}</Typography>
                                                <Typography variant="body1">{description}</Typography>
                                            </div>
                                        )}
                                        buttonComponent={(
                                            <Button variant="contained"
                                                    color="info"
                                                    onClick={() => builtinDeckSelectedCallBack(title)}
                                                    disabled={currentlyUploadingFile}
                                            >
                                                View
                                            </Button>
                                        )}/>
                        ))}
                    </Grid>
                </div>
            )}
            <Typography variant={decks.length > 0 ? "h5" : "h4"} fontWeight="bold" align="center" sx={{mb: 4, mt: 4}}>
                {decks.length > 0 ? "Or upload custom word list" : "Upload custom word list"}
            </Typography>
            <Grid container spacing={3} justifyContent="center">
                <SingleItem title="Anki deck"
                            contentComponent={(
                                <div>
                                    <Typography variant="body1">
                                        Get Anki decks
                                        <a href="https://ankiweb.net/shared/decks" style={{marginLeft: 3}}>here</a>
                                    </Typography>
                                    {currentlyUploadingFile && (
                                        <Box width='100%' mt={2}>
                                            <BarLoader color={theme.palette.info.main} width={'100%'}/>
                                            <Typography variant="body2">Uploading file</Typography>
                                        </Box>
                                    )}
                                    {fileUploadErrorMessage && (
                                        <Typography variant="body1" sx={{color: "red", fontStyle: 'italic'}}>{fileUploadErrorMessage}</Typography>
                                    )}
                                </div>
                            )}
                            buttonComponent={(
                                <Button variant="contained"
                                        color="info"
                                        component="label"
                                        startIcon={<UploadIcon/>} sx={{mb: 1}}
                                        disabled={currentlyUploadingFile}
                                >
                                    Upload
                                    <VisuallyHiddenInput type="file"
                                                         accept=".apkg"
                                                         onChange={handleCustomFileUpload}/>
                                </Button>
                            )}
                />
            </Grid>
        </div>
    )

}

export default DeckSelectionGridView;